"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContext = exports.ContextProvider = exports.Context = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var axios_1 = require("axios");
var settings_1 = require("./settings");
var Context = React.createContext(null);
exports.Context = Context;
function ContextProvider(_a) {
    var application = _a.application, userName = _a.userName, eduzzId = _a.eduzzId, action = _a.action, env = _a.env, returnTo = _a.returnTo, children = _a.children;
    var _b = React.useState({ show: false }), alertConfig = _b[0], setAlertConfig = _b[1];
    var selectedEnv = React.useMemo(function () { return (typeof env === 'string' ? settings_1.ENVS[env] : __assign(__assign({}, settings_1.PRODUCTION_ENV), env)); }, [env]);
    var contextValue = React.useMemo(function () { return ({
        application: application,
        userName: userName,
        eduzzId: eduzzId,
        action: action,
        returnTo: returnTo,
        env: selectedEnv,
        alertConfig: alertConfig
    }); }, [application, userName, eduzzId, action, selectedEnv, returnTo, alertConfig]);
    React.useEffect(function () {
        function getConfig() {
            return __awaiter(this, void 0, void 0, function () {
                var config, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, axios_1.default.get("".concat(selectedEnv.CONFIG_URL, "/fidc-alert-config.json"))];
                        case 1:
                            config = (_a.sent()).data;
                            setAlertConfig(config);
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            console.error(err_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        getConfig();
    }, [selectedEnv.CONFIG_URL]);
    return (0, jsx_runtime_1.jsx)(Context.Provider, __assign({ value: contextValue }, { children: children }));
}
exports.ContextProvider = ContextProvider;
function useContext() {
    var ctx = React.useContext(Context);
    if (!ctx) {
        throw new Error('You must provide a `ContextProvider` in order to use `useContext`');
    }
    return ctx;
}
exports.useContext = useContext;
